import { Box, Grid } from '@mui/material';
import logo from '../../assets/images/logo.png';

export default function NavbarDesktop() {
  return (
    <>
      <Grid container>
        <Grid item xs={2} pl={6} sx={{ zIndex: 1500 }}>
          <Box component={'a'} href="https://kasikorncarabao.com/" sx={{ cursor: 'pointer' }}>
            <img src={logo} alt="logo" width="160" style={{ marginTop: '10px' }} />
          </Box>
        </Grid>

        <Grid item mt={6}></Grid>
      </Grid>
    </>
  );
}
